<template>
  <div class='main-page-content'>
    <div class='flex-sb'>
      <el-form inline :model='searchCondition'>
        <el-form-item label=''>
          <CompanySelect :multiple="true" @handleSelect='selectDept'/>
        </el-form-item>
        <el-form-item>
          <el-input v-model='searchCondition.nickname' placeholder='红人检索：输入关键字' @change='handleQuery' clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model='searchCondition.sign_status' @change='handleQuery'>
            <el-radio label='Y'>在约</el-radio>
            <el-radio label='N'>解约</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type='primary' @click='handleQuery' :disabled='loading' :loading='loading'>查询</el-button>
        </el-form-item>

        <el-form-item>
          <el-link icon='el-icon-upload' type='primary' @click='openImport=true'
                   v-if='hasAuthority("kol_basic_record_import")'>导入表格
          </el-link>
        </el-form-item>
        <el-form-item>
          <export-link class-name='export' ref='refLogisticSubscribeExport'
                       :can-export='hasAuthority("kol_basic_record_export")'
                       @export='handleExport'></export-link>
        </el-form-item>
      </el-form>
      <div class='flex-evenly'>
        <div>
          <DataScope/>
        </div>
        <el-button type='warning' @click='handleShowSetting' icon='el-icon-setting' :disabled='loadingStatus'
                   :loading='loadingStatus' v-if='hasAuthority("kol_basic_record_set")'>列设置
        </el-button>
        <el-button type='primary' @click='handleSync' icon='el-icon-refresh' :disabled='loadingStatus'
                   :loading='loadingStatus' v-if='hasAuthority("kol_basic_record_sync")' plain>同步红人列表
        </el-button>
      </div>
    </div>
    <div v-if='hasAuthority("kol_basic_record_list")'>
      <div
        v-loading='loading'
        element-loading-text='加载中……'
        element-loading-spinner='el-icon-loading'>
        <div>
          <el-tabs type='border-card' class='platforms-tab' :stretch='true' tab-position='left'
                   v-model='tabName' @tab-click='(e)=>handleClick(e.name)' v-if='platforms && platforms.length>0'>
            <template v-for='(platform,indx) in platforms'>
              <el-tab-pane :label='platform.name' :name='`${platform.code}`' :key='`${platform.code}_${indx}`'>
                <span slot='label'>
                  <div style='display: block;height: auto'>
                    <el-avatar shape='square' :size='30' :src='platform.logo_url' @error='true'>
                      <img src='https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png' />
                    </el-avatar>
                    <br />
                    <el-tooltip class='item' effect='dark' :content='`${ platform.name}`' placement='right'>
                      <span class='platform_name'>{{
                        platform.name && platform.name.length > 2 ? platform.name.substring(0, 2) : platform.name
                      }}</span>
                    </el-tooltip>
                  </div>
                </span>
                <div>
                  <div class='default-table' v-if='columns && columns.length>0'>
                    <TablePanel :table-data='tableData' :columns='columns' :key='tabName' @row-dblclick='selectRow'
                                @handleChangeSort='handleChangeSort' :showDept='true' />
                    <div class='flex-sb'>
                      <div>
                        {{ currPlatform.name }}： {{ columns.length }}列
                      </div>
                      <m-pagination @pagination='getList' :limit.sync='pageData.page_size'
                                    :page.sync='pageData.current_page' :total.sync='total'></m-pagination>
                    </div>

                  </div>
                </div>
              </el-tab-pane>
            </template>
          </el-tabs>
        </div>

      </div>
    </div>
    <!--    编辑框-->
    <CreateEdit ref='refCreateEdit' :columns='columns' :currPlatform='currPlatform' @changed='getList'
                v-if='hasAuthority(["kol_basic_record_edit","kol_basic_record_create"])' />

    <!--      导入-->
    <ImportKolBasicRecord :visible.sync='openImport' @imported='handleQuery'
                          v-if='hasAuthority("kol_basic_record_import")' />
    <!--    列设置-->
    <ColSetting ref='refColSetting' @saved='handleLoadCols' v-if='hasAuthority("kol_basic_record_set")' />
  </div>
</template>

<script>

import CreateEdit from './modules/CreateEdit'
import {
  exportKolBasicRecords, getColsBasicRecords,
  getKolBasicRecordList, syncKolBasicRecords
} from '@/api/kol_basic_record'
import TablePanel from '@/pages/artist/base/modules/TablePanel'
import ExportLink from '@/components/export/ExportLink'
import ImportKolBasicRecord from '@/pages/artist/base/modules/ImportKolBasicRecord'
import ColSetting from '@/pages/artist/base/modules/ColSetting'
import DataScope from '@/pages/artist/base/modules/DataScope.vue'


export default {
  name: 'ArtistBaseIndex',
  components: { DataScope, ColSetting, ImportKolBasicRecord, ExportLink, TablePanel, CreateEdit },
  data() {
    return {
      loading: false,
      loadingStatus: false,
      defaultTabName: 'douyin',
      tabName: '',
      tabs: ['douyin', 'xiaohongshu'],
      platforms: [
        { name: '抖音', code: 'douyin', logo_url: '' },
        { name: '小红书', code: 'xiaohongshu', logo_url: '' }
      ],
      currPlatform: {},
      //全部平台
      showPlatforms: [],//显示的平台
      // columns: [],
      columnMap: {
        douyin: { name: '抖音', 'columns': [] },
        xiaohongshu: { name: '小红书', 'columns': [] }
      },
      pageData: { current_page: 1, page_size: 20 },
      searchCondition: {
        sign_status: 'Y',
        dept_id: '',
        nickname: ''
      },
      total: 0,
      tableData: [],
      currentRow: {},
      openImport: false
    }
  },
  computed: {
    columns() {
      return this.columnMap[this.currPlatform.code]?.columns || []
    }
  },
  methods: {
    handleClick(tabName) {
      //切换平台触发
      this.tabName = tabName
      if (this.columnMap[tabName]) {
        this.currPlatform = this.platforms.find(value => value.code === tabName)

        // this.columns = this.columnMap[tabName]?.columns || []
        this.handleQuery()
      }
    },
    handleQuery() {
      this.pageData.current_page = 1
      this.getList()
    },
    async getList() {
      this.loading = true
      this.tableData = []
      this.total = 1000
      const searchCond = this.handleSearchCondition()
      await getKolBasicRecordList(Object.assign(searchCond, this.pageData)).then(({ list, pages }) => {
        this.tableData = list || []
        this.pageData.current_page = pages.current_page
        this.pageData.page_size = pages.page_size
        this.total = pages.total
      })
      // for (let i = 0; i < 25; i++) {
      //   this.tableData.push({ nickname: `KOL_${i}` })
      // }
      this.loading = false
    },
    async selectDept(val) {
      this.searchCondition.group_range = val
      this.handleQuery()
    },
    //获取选中单元格信息
    selectRow(row, column) {
      this.currentRow = row
      this.currentColumn = column
      if (this.hasAuthority('kol_basic_record_edit')) {
        // alert(JSON.stringify(row.nickname))
        if (this.$refs['refCreateEdit'])
          this.$refs['refCreateEdit'].show(row)
      }


    },
    // 获取需要展示的平台
    async getPlatforms() {
      // 获取全部平台信息
      const { list } = await this.$api.getPlatformAll({ is_data_entry: 1, status: 1 })
      //过滤数据
      const showPlatforms = []
      list.forEach((item) => {
        if (this.tabs.indexOf(item.code) > -1) {
          showPlatforms.push({ name: item.name, code: item.code, logo_url: item.logo_url })
        }
      })
      this.platforms = showPlatforms
      // 默认展示的平台
      this.handleClick(this.defaultTabName)
    },

    handleChangeSort(orderSort) {
      this.searchCondition.orderBy = orderSort
      this.handleQuery()
    },
    async handleSync() {
      this.loadingStatus = true
      //发起同步申请
      await syncKolBasicRecords()
      setTimeout(() => {
        this.msgSuccess('已发起同步申请，请刷新页面查看结果')
        this.loadingStatus = false
      }, 2000)

    },
    handleSearchCondition() {
      const condition = {}
      Object.keys(this.searchCondition).forEach((field) => {
        if (this.searchCondition[field]) {
          condition[field] = this.searchCondition[field]
        }
      })

      // 分页 +排序
      Object.assign(condition, { platform_code: this.tabName }, { orderBy: this.orderBy })

      return condition
    },
    //导出表格
    async handleExport() {
      try {
        const searchCondition = this.handleSearchCondition()
        const response = await exportKolBasicRecords(searchCondition)
        const name = `红人基础数据记录`

        this.$refs.refLogisticSubscribeExport.exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        this.$refs.refLogisticSubscribeExport.hideLoading()
      }
    },
    handleShowSetting() {
      if (this.$refs['refColSetting'])
        this.$refs['refColSetting'].show()
    },
    handleLoadCols() {
      // this.columnMap = {}
      getColsBasicRecords({}).then(({ data }) => {
        if (data && data.length > 0) {
          this.activeName = data[0]['platform_code'] || ''
          data.forEach((row) => {
            if (typeof row.content === 'string') {
              row.content = JSON.parse(row.content)
            }
            this.columnMap[row.platform_code] = row.content
          })
        } else {
          this.$confirm('未初始化平台的列, 是否初始化？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (this.$refs['refColSetting']) {
                this.$refs['refColSetting'].handleInit()
            } else {
              this.msgWarn('您没有【列设置】权限')
            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消'
            })
          })
        }
      })
    },
    async handleInit() {
      await this.handleLoadCols()
      await this.getPlatforms()
    }
  },
  created() {
    this.handleInit()
    // console.log(JSON.stringify(columnMap))
  }
}
</script>

<style>
.platforms-tab .el-tabs__item {
  display: block;
  margin: 1px 1px;
  line-height: 25px;
  font-size: 1rem;
  /*word-wrap: break-word;*/
  writing-mode: horizontal-tb;
  height: 80px;
  padding-left: 10px;
  padding-top: 10px;
}
</style>
